module.exports = __webpack_public_path__ + "static/media/friday-che-small-mobile.f0d28061.png";